/**
 * If an entry is deleted, it will return null instead of the entry,
 * therefore we add the filter.
 *
 * This function can be thrown in .filter after the .map,
 * which would actually result in articles.filter(Boolean).map(...).
 * This results in all null/undefined values being removed.
 *
 * We could of course add the .filter(Boolean) directly in the render,
 * but that would mean we would need to add this comment to every place
 * where we render entries. This function is more descriptive.
 **/
export const deletedEntries = Boolean;
